import React from "react";
import "./windshieldCoating.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
export default function WindshieldCoating() {
  return (
    <>
    <Helmet>
      <title>Best Windshield Coating Service in Palwal | AutoCare</title>
      <meta
        name="description"
        content="Drive safer in all weather conditions with professional windshield coating service at AutoCare in Palwal. We offer advanced car repair & detailing solutions for superior visibility and protection."
      />
      <link
        rel="canonical"
        href="https://car-repair-mechanic-palwal.netlify.app/services/windshield-coating"
      />
    </Helmet>
    <section className="servicePage">
      <div className="serviceContent">

        {/* TEXT CONTENT */}
        <div className="textContent">
          <h1>Best Windshield Coating Service in Palwal</h1>

          <p>
            Drive safer in all weather conditions with
            <strong> professional windshield coating service</strong> at
            <span className="highlight"> AutoCare</span>.
            We are a trusted <span className="highlight">Auto Care in Palwal</span>
            offering advanced <strong>car repair & detailing solutions</strong>
            for superior visibility and protection.
          </p>

          <h2>What is Windshield Coating?</h2>
          <p>
            Windshield coating is a protective treatment applied to your
            car’s glass that repels water, dust, and dirt. It improves visibility
            during rain, reduces glare, and enhances driving safety.
          </p>

          <h2>Benefits of Windshield Coating</h2>
          <ul>
            <li>Improves visibility during rain & fog</li>
            <li>Water & dirt repellent glass protection</li>
            <li>Reduces glare from headlights</li>
            <li>Prevents minor scratches on glass</li>
            <li>Makes windshield cleaning easier</li>
          </ul>

          <h2>Why Choose AutoCare for Windshield Coating?</h2>
          <ul>
            <li>One of the <span className="highlight">best windshield coating services in Palwal</span></li>
            <li>Premium hydrophobic coating products</li>
            <li>Experienced auto detailing professionals</li>
            <li>Affordable pricing & transparent service</li>
            <li>Trusted <span className="highlight">Auto Care in Palwal</span> for car repair</li>
          </ul>

          <h2>Book Windshield Coating Near You</h2>
          <p>
            Searching for the <span className="highlight">best windshield coating near me</span>?
            Choose <strong>AutoCare</strong> for long-lasting glass protection,
            improved driving safety, and professional car care.
          </p>

          <button className="primaryBtn">
            <Link to="/contact">
            Book Windshield Coating Service
            </Link>
          </button>
        </div>

        {/* IMAGE CONTENT */}
        <div className="imageContent">
          <img
            src='/carServiceImages/windshieldCoating.webp'
            alt="Best Windshield Coating Service in Palwal by AutoCare"
          />
        </div>

      </div>
    </section>
    </>
  );
}
